module.exports = __webpack_public_path__ + "img/buissonniere-e-commerce-success-story-img-1.1c4b9ff2.jpeg";